import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for AI Usage (/ai-usage → AiUsagePage.tsx, the regular agent view). */
export function getAiUsageTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'AI usage',
        description:
          'See how much of your plan’s monthly AI allowance you’ve used, if your plan includes ' +
          'one. It resets at the start of each calendar month. Free actions, like page and menu ' +
          'changes, never count against it.',
      },
    },
    {
      element: at('usage-bar'),
      popover: {
        title: 'How much you’ve used',
        description:
          'This bar shows how much of this month’s allowance you have used. At 80% you’ll see a ' +
          'warning.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: at('usage-card'),
      popover: {
        title: 'When you reach the limit',
        description:
          'AI writing and building pause until the month resets. Your website stays live and free ' +
          'actions keep working.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('usage-upgrade'),
      popover: {
        title: 'Keep going',
        description:
          'Upgrade your plan for a bigger allowance. You can also add credits under My Account → ' +
          'Billing & Payments.',
        side: 'bottom',
        align: 'start',
      },
    },
  ];
}
